import { EditProfileMediaDocumentsProvider } from '../../context/EditProfileMediaDocumentsProvider';
import EditProfileMediaDocumentsImage from '../EditProfileMediaDocumentsImage/EditProfileMediaDocumentsImage';

const EditProfileMediaDocuments = () => {
  return (
    <EditProfileMediaDocumentsProvider>
      <div style={{ marginTop: 10 }}>
        <EditProfileMediaDocumentsImage key={'Image'} />
      </div>
    </EditProfileMediaDocumentsProvider>
  );
};

export default EditProfileMediaDocuments;
